
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/charity",
      function () {
        return require("private-next-pages/charity.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/charity"])
      });
    }
  